window.edussGlobalVars = {
    appName: 'Eduss',
    primaryColor: '#007bff',
    secondaryColor: '#6c757d',
    apiBaseUrl: '/api',
    // Add more global variables or utility functions as needed
  };
  
  export default window.edussGlobalVars;
  